import AxiosControl from '../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getParameters = (startDate, endDate) => async (dispatch) => {
    dispatch({
        type: 'PARAMETER_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/parameter/getall/', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'PARAMETER_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'PARAMETER_NOT_LOADING'
        })
    }
}

export const getParameter = (parameter) => async (dispatch) => {
    dispatch({
        type: 'PARAMETER_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/parameter/get/'+ parameter, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'PARAMETER_GET_SUCCESS',
                payload: data.parameter
            })
        }
    } catch (error) {
        dispatch({
            type: 'PARAMETER_NOT_LOADING'
        })
    }
}

export const addParameter = (parameterdata) => async (dispatch) => {
    dispatch({
        type: 'PARAMETER_LOADING'
    })
    try {
        const { data, status} = await Axios.post('/api/parameter/register', parameterdata, {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'PARAMETER_ADD_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'PARAMETER_NOT_LOADING'
        })
    }
}

export const editParameter = (parameterdata, idParameter) => async (dispatch) => {
    try {
        const { data, status} = await Axios.put('/api/parameter/edit/' + idParameter, parameterdata, {
                headers: {
                    auth: localStorage.getItem('jwt')
                }
            }
        )
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'PARAMETER_EDIT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'PARAMETER_ERROR'
        })
    }
}

export const removeParameter = (parameter) => async (dispatch) => {
    try {
        const { data, status } = await Axios.delete('/api/parameter/remove/' + parameter, {
            headers: {
                auth: localStorage.getItem('jwt')
            }
        })
        if (status === 200 || status === 263) {
            dispatch({
                type: 'PARAMETER_REMOVE_RESULT',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'PARAMETER_NOT_LOADING'
        })
    }
}

export const resetParameter = () => async (dispatch) => {
    dispatch({
        type: 'PARAMETERS_RESET'
    })
}